import { useEffect, useRef } from 'react';
import { NetworkState } from 'src/constants/network-state';
import { useAppDispatch, useAppSelector } from 'src/hooks/hooks';
import {
  fetchAbilityRole,
  hydrateAbilityRolesFromCache,
  readAbilityRoleCache,
} from 'src/redux/ability-roles/abilityRoleSlice';

export const useAbilityRoleBootstrap = (isUrlNavigationEnabled: boolean) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const abilityRoleStatus = useAppSelector((state) => state.abilityRole.status);
  const abortRequestRef = useRef<(() => void) | null>(null);

  useEffect(
    () => () => {
      abortRequestRef.current?.();
      abortRequestRef.current = null;
    },
    [user.user?.uid]
  );

  useEffect(() => {
    const uid = user.user?.uid;

    if (!uid || user.status !== NetworkState.SUCCESS) {
      return;
    }

    if (abilityRoleStatus !== NetworkState.NOT_STARTED) {
      return;
    }

    if (!isUrlNavigationEnabled) {
      const request = dispatch(fetchAbilityRole(uid));
      abortRequestRef.current = () => request.abort();
      return;
    }

    const cachedRoles = readAbilityRoleCache(uid);
    if (cachedRoles && cachedRoles.length > 0) {
      dispatch(hydrateAbilityRolesFromCache(cachedRoles));
      return;
    }

    const request = dispatch(fetchAbilityRole(uid));
    abortRequestRef.current = () => request.abort();
  }, [
    abilityRoleStatus,
    dispatch,
    isUrlNavigationEnabled,
    user.status,
    user.user?.uid,
  ]);
};
